module.exports = __webpack_public_path__ + "media/images/golf-594f5aa43b2205af1954f67d39a5ad11.svg";